var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',[_c('b-row',{ref:"row"},[_c('b-col',[_c('h2',[_vm._v(_vm._s(_vm.$t("home.driver.title", { userName: _vm.userName })))])])],1),_c('driver-dashboard',{attrs:{"offsetTop":_vm.offsetTop}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }